import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NONE } from '../../scripts/models/request-status';

import { CodeB, Sso, SsoState } from './ssoTypes';

export const initialState: SsoState = {
  sso: {
    isLoadingActivate: false,
    accessToken: null,
    ssoEnabled: false,
    isActive: false
  },
  codeB: {
    body: null,
    status: NONE
  }
};

const ssoSlice = createSlice({
  name: 'sso',
  initialState,
  reducers: {
    setSsoData(state, action: PayloadAction<Omit<Sso, 'isLoadingActivate'>>) {
      state.sso = { ...action.payload, isLoadingActivate: state.sso.isLoadingActivate };
    },
    setCodeB(state, action: PayloadAction<CodeB>) {
      state.codeB = action.payload;
    },
    setIsLoadingActivate(state, action: PayloadAction<boolean>) {
      state.sso.isLoadingActivate = action.payload;
    },
    setActivated(state) {
      state.sso.isLoadingActivate = false;
      state.sso.isActive = true;
    },
    setCodeBStatus(state, action: PayloadAction<string>) {
      state.codeB.status = action.payload;
    }
  }
});

export const ssoReducer = ssoSlice.reducer;
export const ssoActions = ssoSlice.actions;

export const {
  setSsoData,
  setCodeB,
  setActivated,
  setIsLoadingActivate,
  setCodeBStatus
} = ssoActions;
